export default "__VITE_ASSET__CcKhqURQ__"